import React, { useState } from "react";
import { DialogActions, DialogContent, Dialog, DialogTitle, Box, TextField, Grid, Button, CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';
import { cpfMask } from "../../services/funcoesAuxiliares";
import { Copy } from "lucide-react";
import copy from "copy-to-clipboard";

const CadastrarVendedor = ({ show, cadastroVendedores, props, handleClose}) => {
  const [isLoading, setIsLoading] = useState(false);

  const { nome, setNome, cpf, setCpf, telefone, setTelefone, expiraEm, setExpiraEm, creationLink } = props;

  const handleCadastro = async () => {
    setIsLoading(true);
    await cadastroVendedores(nome, cpf, telefone, expiraEm);
    setIsLoading(false);
  }

  const handleCopyLink = () => {
    copy(creationLink);
    toast.success("Link copiado para a área de transferência!");
  }

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ backgroundColor: '#1e3a8a', color: 'white' }}> Cadastrar Colaborador </DialogTitle>
      <DialogContent sx={{ paddingTop: 2 }}>
        { creationLink ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 2 }}>
            <p>Colaborador criado com sucesso!</p>
            <p>Link para criação de carteira:</p>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
              <a href={creationLink} target="_blank" rel="noreferrer">{creationLink}</a>
              <Button onClick={handleCopyLink} sx={{ ml: 1 }}><Copy /></Button>
            </Box>
          </Box>
        ) : (
        <Box
          component="form"
          sx={{ mt: 2 }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField fullWidth id="Name-Basic" value={nome} onChange={({ target }) => setNome(target.value)} label="Nome" variant="outlined" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth id="Cpf-basic" value={cpf} onChange={({ target }) => setCpf(cpfMask(target.value))} label="Cpf" variant="outlined" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth id="Telefone-basic" value={telefone} onChange={({ target }) => setTelefone(target.value)} label="Telefone" variant="outlined" />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth id="Expira-basic" type="date" value={expiraEm} onChange={({ target }) => setExpiraEm(target.value)} label="Expira em" variant="outlined" InputLabelProps={{ shrink: true }} />
            </Grid>
          </Grid>
        </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>FECHAR</Button>
        {!creationLink && (
          <Button 
            onClick={handleCadastro} 
            autoFocus 
            variant="contained" 
            sx={{ backgroundColor: '#1e3a8a', '&:hover': { backgroundColor: '#1c357a' } }}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} color="inherit" /> : "CADASTRAR"}
          </Button>
        )}
      </DialogActions>
    </Dialog>)

}

export default CadastrarVendedor;
